import { jsx as o } from "react/jsx-runtime";
import { useStyleConfig as g, chakra as i } from "@chakra-ui/react";
import { SgiCanadaLogoSvg as n } from "./SgiCanadaLogoSvg.mjs";
const l = ({ ...a }) => {
  const r = g("SgiCanadaLogo");
  return /* @__PURE__ */ o(i.span, { __css: r, role: "img", "aria-label": "SGI Canada logo", ...a, children: /* @__PURE__ */ o(n, {}) });
};
export {
  l as SgiCanadaLogo
};
